
import React from 'react';

const testimonials = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    role: 'Real Estate Investor',
    content: 'Jeffery\'s infinite banking concepts completely transformed how I think about money and investments. His practical approach made complex financial strategies accessible and actionable.',
    rating: 5,
    book: 'Infinite Banking Concept'
  },
  {
    id: 2,
    name: 'Michael Chen',
    role: 'Tech Entrepreneur',
    content: 'The AI investing strategies in Jeffery\'s books gave me the edge I needed in the crypto market. His data-driven approach to trading bots has been incredibly valuable.',
    rating: 5,
    book: 'AI-Powered Trading Bots'
  },
  {
    id: 3,
    name: 'Jennifer Rodriguez',
    role: 'Financial Advisor',
    content: 'As a financial professional, I recommend Jeffery\'s books to my clients regularly. His expertise in tax sales overages has helped many recover thousands in unclaimed funds.',
    rating: 5,
    book: 'Tax Sales Overages'
  },
  {
    id: 4,
    name: 'David Thompson',
    role: 'Business Owner',
    content: 'The prosperity principles in Jeffery\'s latest book helped me restructure my business finances and achieve the financial freedom I\'d been seeking for years.',
    rating: 5,
    book: 'The Prosperity Puzzle'
  }
];

export const TestimonialsSection: React.FC = () => {
  const renderStars = (rating: number) => {
    return (
      <div className="flex">
        {[...Array(rating)].map((_, i) => (
          <i key={i} className="ri-star-fill text-yellow-400"></i>
        ))}
      </div>
    );
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">What Readers Are Saying</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover how my books have helped thousands of readers achieve financial success and personal growth.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              <div className="mb-4">
                {renderStars(testimonial.rating)}
              </div>
              
              <blockquote className="text-gray-700 mb-6 italic">
                "{testimonial.content}"
              </blockquote>
              
              <div className="border-t pt-4">
                <div className="font-semibold text-gray-900">{testimonial.name}</div>
                <div className="text-sm text-gray-600 mb-2">{testimonial.role}</div>
                <div className="text-xs text-blue-600 font-medium">
                  Reader of: {testimonial.book}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Newsletter Signup */}
        <div className="mt-16 bg-white rounded-2xl shadow-lg p-8 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">Stay Updated on New Releases</h3>
          <p className="text-gray-600 mb-6">
            Be the first to know when I publish new books and get exclusive insights on financial strategies.
          </p>
          
          <form className="max-w-md mx-auto flex gap-4">
            <input
              type="email"
              placeholder="Enter your email"
              className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              required
            />
            <button
              type="submit"
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition-colors whitespace-nowrap"
            >
              Subscribe
            </button>
          </form>
          
          <p className="text-sm text-gray-500 mt-4">
            No spam, unsubscribe at any time. Your email is safe with us.
          </p>
        </div>
      </div>
    </section>
  );
};
